import { Button, ButtonProps, Skeleton, Text } from '@chakra-ui/react'
import { FC } from 'react'

interface TabProps extends ButtonProps {
  selected?: boolean
  tabName: string
}

export const Tab: FC<TabProps> = ({ selected, tabName, ...rest }) => {
  return (
    <Button
      width={'120px'}
      height={'70px'}
      backgroundColor={selected ? 'primary.4' : 'secondary.1'}
      alignContent={'center'}
      justifyItems={'center'}
      borderRadius={'xl'}
      overflow={'hidden'}
      {...rest}>
      <Text
        color={selected ? 'text.8' : 'text.1'}
        fontSize={'xs'}
        width={'full'}
        whiteSpace={'normal'}>
        {tabName}
      </Text>
    </Button>
  )
}

export const SkeletonTab: FC = () => (
  <Skeleton borderRadius={'xl'} width={'120px'} height={'70px'} />
)
